import { render, staticRenderFns } from "./BusinessLaunchWeApp.vue?vue&type=template&id=0d2cca0c&"
import script from "./BusinessLaunchWeApp.vue?vue&type=script&lang=ts&"
export * from "./BusinessLaunchWeApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports